import { Spinner, Text, VStack } from '@chakra-ui/react';
import { Card } from '../shared/Card'
import { useMergeFields } from '../../hooks/useCommunications'
import type { EmailSourceKind } from '../../types/communications'

/** Key / description / sample legend for every merge field available to this source (spec §6/§8) —
 * feeds the same `useMergeFields` catalog the "Insert field ▾" dropdown reads from. */
export function MergeFieldLegend({ source }: { source: EmailSourceKind | undefined }) {
  const { data: fields, isLoading } = useMergeFields(source)

  return (
    <Card>
      <Text fontWeight="semibold" mb={1}>Merge fields</Text>
      <Text fontSize="xs" color="fg.muted" mb={3}>
        Insert into the body from the toolbar, or type into the subject manually.
      </Text>
      {isLoading && <Spinner size="sm" color="accent" />}
      {!isLoading && (
        <VStack align="stretch" gap={3}>
          {(fields ?? []).map((f) => (
            <VStack key={f.key} align="stretch" gap={0}>
              <Text fontSize="sm" fontFamily="mono">{`{{${f.key}}}`}</Text>
              <Text fontSize="xs" color="fg.muted">{f.description} — e.g. "{f.sample}"</Text>
            </VStack>
          ))}
          {!!fields && fields.length === 0 && (
            <Text fontSize="sm" color="fg.muted">No merge fields available for this source.</Text>
          )}
        </VStack>
      )}
    </Card>
  );
}
